import { IRoleEnum } from "@interfaces";
import { createRoute } from "@routes/utils";

import { employeeListRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";

const permission = [IRoleEnum.STORE];

const employeeListRouteMetadata: IRouteMetadataObj<
  typeof employeeListRoutesObj
> = {
  list: {
    title: "basicInfo.index.title",
    description: "empty",
    lazy: () => import("@pages/basicInfo/employee/table/page"),
    mode: "index",
    type: "main",
    icon: "Information2Line",
    breadcrumbs: [],
    permission,
  },
  create: {
    title: "basicInfo.employeeManagement.create.title",
    description: "empty",
    lazy: () => import("@/pages/basicInfo/employee/form/page"),
    mode: "create",
    type: "inner",
    icon: "AddLine",
    breadcrumbs: [],
    permission,
  },
  edit: {
    title: "basicInfo.employeeManagement.edit.title",
    description: "empty",
    lazy: () => import("@/pages/basicInfo/employee/form/page"),
    mode: "edit",
    type: "inner",
    icon: "EditLine",
    breadcrumbs: [],
    permission,
  },
  view: {
    title: "basicInfo.employeeManagement.view.title",
    description: "empty",
    lazy: () => import("@/pages/basicInfo/employee/form/page"),
    mode: "view",
    type: "inner",
    icon: "EditLine",
    breadcrumbs: [],
    permission,
  },
  warehouseList: {
    title: "basicInfo.employeeManagement.warehouseList.title",
    description: "empty",
    lazy: () =>
      import("@/pages/basicInfo/employee/employeeWarehouses/table/page"),
    mode: "index",
    type: "inner",
    icon: "Building2Line",
    breadcrumbs: [],
    permission,
  },
  addNewWarehouse: {
    title: "basicInfo.employeeManagement.newWarehouse.title",
    description: "empty",
    lazy: () =>
      import("@/pages/basicInfo/employee/employeeWarehouses/form/page"),
    mode: "create",
    type: "inner",
    icon: "EyeLine",
    breadcrumbs: [],
    permission,
  },
  resetEmployeePassword: {
    title: "basicInfo.employeeManagement.resetEmployeePassword.title",
    description: "empty",
    lazy: () => import("@/pages/basicInfo/employee/resetPassword/form/page"),
    mode: "create",
    type: "inner",
    icon: "LockLine",
    breadcrumbs: [],
    permission,
  },
};

export const employeeListRoutes = createRoute<typeof employeeListRoutesObj>(
  employeeListRoutesObj,
  employeeListRouteMetadata,
);
